import { Box, BoxProps } from "@samacare/design";

export const TopBottom: React.FC<BoxProps> = ({ sx, children }) => (
  <Box display="flex" flexDirection="column" sx={sx}>
    {children}
  </Box>
);

export const TopBottomCenterH: React.FC<BoxProps> = ({ sx, children }) => (
  <Box display="flex" flexDirection="column" alignItems="center" sx={sx}>
    {children}
  </Box>
);

export const TopBottomSpreadCenterH: React.FC<BoxProps> = ({
  sx,
  children,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="space-between"
    sx={sx}
  >
    {children}
  </Box>
);

export const TopBottomCenterAll: React.FC<BoxProps> = ({ sx, children }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    sx={sx}
  >
    {children}
  </Box>
);
